import { useAppDispatch, useAppSelector } from '../../../hooks'
import { selectPickedViewIds } from '../../views/viewsSlice'
import { _upsertCachedView, type CachedView } from '../cachedViewsSlice'

export const useUpsertCachedView = () => {
  const dispatch = useAppDispatch()
  const cacheableViewIds = useAppSelector(selectPickedViewIds)

  return (overridingCachedView: CachedView): void => {
    dispatch(_upsertCachedView({ overridingCachedView, cacheableViewIds }))
  }
}
